import { FormData } from '../forms-ui-form-faas.interface';
import { FormSubmissionPayload } from '../forms-ui-form-payload.interface';
import { trimTrailingSlash } from '../util/form-util';

export interface IFaaSDataClient {
  getFormMetadata(): Promise<FormData>
  submitForm(payload: FormSubmissionPayload, testMode: boolean): Promise<Response>
}

export class FaaSDataClient implements IFaaSDataClient {
	private apiBaseUrl: string;

	private metadataRetrievalUrl: string;

	private formId: string;

	private locale: string;

	constructor(apiBaseUrl: string, formId: string, metadataRetrievalUrl: string, locale: string) {
		this.apiBaseUrl = trimTrailingSlash(apiBaseUrl);
		this.formId = formId;
		this.metadataRetrievalUrl = trimTrailingSlash(metadataRetrievalUrl);
		this.locale = locale;
	}

	/** Retrieve form metadata from the faas API. If debug is true, returns a hardcoded form metadata. */
	async getFormMetadata(): Promise<FormData> {
		let getFormMetaDataFullUrl = `${this.metadataRetrievalUrl}/forms/${this.formId}`;
		getFormMetaDataFullUrl = this.locale ? `${getFormMetaDataFullUrl}/${this.locale}` : getFormMetaDataFullUrl;
		const formResponse = await fetch(getFormMetaDataFullUrl);
		if (!formResponse.ok) {
			throw new Error(`Failed to fetch form metadata: ${formResponse.status}: ${formResponse.statusText}`);
		}
		const response = await formResponse.json();
		return response as FormData;
	}

	async submitForm(payload: FormSubmissionPayload, testMode: boolean): Promise<any> {
		const headers = {
			'Content-Type': 'application/json',
			sessionId: sessionStorage.getItem('nuCaptchaSessionId'),
			testMode: String(testMode),
		};

		const response = await fetch(
			`${this.apiBaseUrl}/`,
			{
				method: 'POST',
				headers,
				body: JSON.stringify(payload),
			},
		);

		if (!response.ok) {
			throw new Error(`Failed to submit form: ${response.status}: ${response.statusText}`);
		}

		return response.json();
	}
}

export const createFaaSDataClient = (apiBaseUrl: string, metadataRetrievalUrl: string, formId: string, locale: string):
	IFaaSDataClient => new FaaSDataClient(apiBaseUrl, formId, metadataRetrievalUrl, locale);
